import './CheckoutEvent.css'
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Loginpopup from "../Navbar/Loginmodal";
import iziToast from 'izitoast';
import { FaLocationDot, FaArrowLeft } from "react-icons/fa6";
import { SlCalender } from "react-icons/sl";
import 'izitoast/dist/css/iziToast.min.css';
import { API_BASE_URL } from '../utils';
import CouponModal from '../My--Bidding--design/CouponModal';
import PlatformChargesTooltip from '../My--Bidding--design/comp/PlatformChargesTooltip';

// Utility function to format Indian currency
const formatIndianCurrency = ((amount) => {
    if (amount === 0) return "₹0.00";

    const [whole, decimal = "00"] = parseFloat(amount)
        .toFixed(2) // Ensures two decimal digits
        .split(".");

    const lastThree = whole.substring(whole.length - 3);
    const otherNumbers = whole.substring(0, whole.length - 3);

    const formattedWhole = otherNumbers
        ? otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree
        : lastThree;

    return `₹${formattedWhole}.${decimal}`;
});


export default function CheckoutEvent() {
    const navigate = useNavigate();

    // User data
    const userdata = useMemo(() => {
        try {
            return JSON.parse(localStorage.getItem("userData"));
        } catch {
            return null;
        }
    }, []);
    // State management
    const [checkoutData, setCheckoutData] = useState(null);
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [useCarrotBalance, setUseCarrotBalance] = useState(true);
    const [useCarrot, setUseCarrot] = useState(false)
    const [tncAccepted, setTncAccepted] = useState(true);
    const [couponAmount, setCouponAmount] = useState(0);
    const [platformFee, setPlatformFee] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [usableCarrot, setUsableCarrot] = useState(0);

    const [showModal, setShowModal] = useState(false);
    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [availableCoupons, setAvailableCoupons] = useState([]);
    const [orderData, setOrderData] = useState(null);

    const [error, setError] = useState(null);

    const [initialValuesCoupon, setInitialValuesCoupon] = useState(null);
    const [paymentGateway, setPaymentGateway] = useState("razorpay");
    const [orderID, setOrderID] = useState(null);
    const [isFreeTikets, setIsFreeTickets] = useState(false);
    const [processing, setProcessing] = useState(false); // ✅ Added




    const isCarnival = checkoutData?.type === "carnival";

    console.log('isCarnival ', isCarnival);


    // ✅ Calculate amounts safely
    const calculateAmounts = useCallback(() => {
        if (!orderData) return null;

        const num = (val) => parseFloat(val) || 0;

        const baseAmount = num(orderData.total_amount);
        const payableAmount = num(orderData?.payable_amount);
        const netPayableAmount = num(orderData?.net_payable_amount);
        const dueAmount = num(orderData?.due_amount);
        const usableCarrot = num(orderData?.usableCarrot);
        const platformFee = num(orderData?.platform_fee);
        const clubAdvance = num(orderData?.club_advance_amount);
        const pwCommAmount = num(orderData?.pw_total_comm_amount);

        // ✅ Coupon discount
        let couponDiscount = 0;

        if (selectedCoupon) {
            const minSpent = num(selectedCoupon.min_spent);
            if (payableAmount >= minSpent) {
                if (selectedCoupon.discount_type === "percent") {
                    couponDiscount = (payableAmount * num(selectedCoupon.discount)) / 100;
                    if (selectedCoupon.capping) {
                        couponDiscount = Math.min(couponDiscount, num(selectedCoupon.capping));
                    }
                } else {
                    couponDiscount = num(selectedCoupon.discount);
                }
            }
        }

        // ✅ Carrot discount
        const carrotDiscount = useCarrot
            ? Math.min(usableCarrot, payableAmount * 0.1)
            : 0;

        // ✅ Final Payable
        const finalPayableAmount =
            netPayableAmount -
            carrotDiscount -
            (initialValuesCoupon?.id === selectedCoupon?.id ? 0 : couponDiscount);

        return {
            baseAmount,
            payableAmount,
            netPayableAmount,
            dueAmount,
            usableCarrot,
            platformFee,
            clubAdvance,
            pwCommAmount,
            carrotDiscount,
            couponDiscount,
            finalPayableAmount: Math.max(0, finalPayableAmount),
        };
    }, [orderData, useCarrot, selectedCoupon, initialValuesCoupon]);

    const amounts = calculateAmounts();


    // Constants
    const freePlatformFee = 50.00;
    const gstPercentage = 18;
    const carrotDiscount = 50.00;


    // Calculate totals
    const calculations = useMemo(() => {
        if (!checkoutData) return { finalAmount: 0, totalQty: 0 };

        const ticketTotal = checkoutData.selectedTickets.reduce((total, ticket) => {
            return total + (parseFloat(ticket.price) || 0) * ticket.quantity;
        }, 0);

        const totalQty = checkoutData.selectedTickets.reduce((sum, ticket) => sum + ticket.quantity, 0);

        // For free tickets, fixed pricing: 50 rs + 18% GST = 59 rs
        if (checkoutData.isFreeTiket) {
            const gstAmount = (freePlatformFee * gstPercentage) / 100;
            const finalAmount = freePlatformFee + gstAmount;

            return {
                ticketTotal: 0,
                totalQty,
                platformFee: freePlatformFee,
                gstAmount,
                carrotDiscount: 0,
                finalAmount,
                isFreeTiket: true
            };
        }

        // For paid tickets
        const carrotDiscountAmount = useCarrotBalance ? carrotDiscount : 0;
        const finalAmount = Math.max(0, ticketTotal + 5.9 - carrotDiscountAmount);

        return {
            ticketTotal,
            totalQty,
            platformFee: 5.9,
            gstAmount: 0,
            carrotDiscount: carrotDiscountAmount,
            finalAmount,
            isFreeTiket: false
        };
    }, [checkoutData, useCarrotBalance]);

    // Script loader
    const loadScripts = useCallback((src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    }, []);

    // Create Razorpay order
    const createRazorpayOrder = useCallback(async (amount) => {
        try {
            const formdata = new FormData();
            formdata.append("user_id", userdata?.id || "");
            formdata.append("amount", amount);

            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/ClubEvent/createOrder`,
                formdata
            );

            return response.data.order_id;
        } catch (error) {
            console.error("Error creating Razorpay order:", error);
            throw new Error("Failed to create payment order");
        }
    }, [userdata]);

    // Verify Razorpay payment
    const verifyRazorpayPayment = useCallback(async (razorpayResponse) => {
        try {
            const formdata = new FormData();
            formdata.append("response", JSON.stringify(razorpayResponse));

            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/Carnival/verifyRzpPayment`,
                formdata
            );

            const verificationResponse = response.data;

            if (verificationResponse.status) {
                iziToast.success({
                    title: 'Success',
                    message: verificationResponse.msg,
                    timeout: 5000,
                    position: 'topCenter',
                });
                return true; // ✅ Success
            } else {
                iziToast.error({
                    title: 'Verification Failed',
                    message: verificationResponse.msg || 'Payment verification failed.',
                    timeout: 5000,
                    position: 'topCenter',
                });
                return false; // ❌ Failure
            }
        } catch (error) {
            console.error("Error verifying payment:", error);
            iziToast.error({
                title: 'Error',
                message: 'An error occurred while verifying the payment.',
                timeout: 5000,
                position: 'topCenter',
            });
            return false; // ❌ Failure
        }
    }, []);


    // Handle Razorpay payment
    const handleRazorpayScreen = useCallback(async (data) => {

        console.log("Razorpay data:", data);

        try {
            const res = await loadScripts('https://checkout.razorpay.com/v1/checkout.js');
            if (!res) {
                throw new Error("Failed to load Razorpay script");
            }

            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY,
                amount: data.net_payable_amount * 100,
                currency: "INR",
                name: "PartyWitty",
                description: `Event Ticket Booking ${data.orderId}`,
                order_id: data.rzp_order_id,
                handler: async function (response) {
                    try {
                        const verified = await verifyRazorpayPayment(response);
                        if (verified) {
                            window.location.href = "/event/thank-you";
                        } else {
                            iziToast.error({
                                title: 'Verification Failed',
                                message: 'Payment verification failed. Please contact support.',
                                timeout: 3000,
                                position: 'topCenter',
                            });
                        }
                    } catch (err) {
                        console.error("Verification error:", err);
                        iziToast.error({
                            title: 'Verification Error',
                            message: 'Error during payment verification. Please try again.',
                            timeout: 3000,
                            position: 'topCenter',
                        });
                    }
                },
                prefill: {
                    name: userdata?.name || "Guest",
                    email: userdata?.email || "guest@partywitty.com",
                },
                theme: {
                    color: "#f4c438",
                },
                modal: {
                    ondismiss: function () {
                        iziToast.error({
                            title: 'Payment Cancelled',
                            message: 'Payment was cancelled by the user.',
                            timeout: 3000,
                            position: 'topCenter',
                        });
                    }
                }
            };

            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        } catch (error) {
            console.error("Error opening Razorpay:", error);
            iziToast.error({
                title: 'Payment Error',
                message: 'Error processing payment. Please try again.',
                timeout: 3000,
                position: 'topCenter',
            });
        }
    }, [loadScripts, verifyRazorpayPayment, userdata]);


    // Handle place order 
    const handleEventPlaceOrder = useCallback(async () => {
        if (isCarnival) {
            return;
        }

        if (!userdata) {
            setShowLoginPopup(true);
            return;
        }

        console.log("Checkout data in fn :", checkoutData);

        if (!checkoutData) {
            iziToast.error({
                title: 'Error',
                message: 'No ticket data found',
                timeout: 3000,
                position: 'topCenter',
            });
            return;
        }

        setLoading(true);

        try {
            const qty = checkoutData.selectedTickets.map(ticket => ticket.quantity).join(',');
            const ticket_id = checkoutData.selectedTickets.map(ticket => ticket.id).join(',');

            const formdata = new FormData();
            formdata.append("user_id", userdata.id);
            formdata.append("qty", qty);
            formdata.append("ticket_id", ticket_id);
            formdata.append("platform", "web");
            formdata.append("use_carrot_balance", useCarrotBalance ? "1" : "0");

            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/ClubEvent/placeOrder`,
                formdata
            );

            const data = response.data;

            if (data.status) {
                // if (data.data.rzp_order_id === "") {
                //     // Free booking
                //     window.location.href = "/event/thank-you";
                // } else {
                // Paid booking
                // await handleRazorpayScreen(data);
                setOrderData(data.data);
                // }
            } else {
                throw new Error(data.msg || "Failed to book tickets");
            }
        } catch (error) {
            console.error("Error placing order:", error);
            iziToast.error({
                title: 'Booking Error',
                message: error.message || 'Failed to book tickets. Please try again.',
                timeout: 5000,
                position: 'topCenter',
            });
        } finally {
            setLoading(false);
        }
    }, [userdata, checkoutData, useCarrotBalance, handleRazorpayScreen]);

    // Handle checkbox change
    const handleCheckboxChange = useCallback((e) => {
        setUseCarrotBalance(e.target.checked);
    }, []);

    // Go back to ticket selection
    const handleGoBack = useCallback(() => {
        navigate(-1);
    }, [navigate]);


    // Carnival start

    const placeOrder = async () => {

        const orderForm = new FormData();
        orderForm.append("user_id", userdata?.id);
        orderForm.append("bid_id", "0");
        orderForm.append("coupon_code", "");
        orderForm.append("selected_pass_id", checkoutData?.eventDetails.id || "");
        orderForm.append("name[]", userdata?.name || "Guest");
        orderForm.append("gender[]", userdata?.gender || "");
        // Always set defaults first
        orderForm.append("couple_qty", 0);
        orderForm.append("male_qty", 0);
        orderForm.append("female_qty", 0);

        // Then update if tickets exist
        checkoutData.selectedTickets.forEach((ticket) => {
            if (ticket.ticket_type === "Couple") {
                orderForm.set("couple_qty", ticket.quantity || 0);
            }
            if (ticket.ticket_type === "Male Stag") {
                orderForm.set("male_qty", ticket.quantity || 0);
            }
            if (ticket.ticket_type === "Female Stag") {
                orderForm.set("female_qty", ticket.quantity || 0);
            }
        });

        orderForm.append("carrot_use", checkoutData?.eventDetails.usableCarrot || 0);


        if (orderForm) {
            if (!tncAccepted) {
                alert('Please review and accept the Terms & Conditions');
                return;
            }

            const orderResult = await axios.post(`${API_BASE_URL}/master/APIs/Carnival/PlaceOrder`, orderForm);
            console.log('Order Result: ', orderResult);

            if (orderResult?.status) {
                const order = orderResult.data;

                setOrderData(order.data);
                setOrderID(order.data.order_id);
                // ✅ Applied coupon parse
                if (orderResult?.data?.applied_coupon) {
                    let parsedCoupon = orderResult.data.applied_coupon;

                    // Handle string case
                    if (typeof parsedCoupon === "string") {
                        try {
                            parsedCoupon = JSON.parse(parsedCoupon);
                        } catch (err) {
                            console.error("Failed to parse applied_coupon:", parsedCoupon, err);
                            parsedCoupon = null;
                        }
                    }

                    // Only set if it's a non-empty object
                    if (parsedCoupon && typeof parsedCoupon === "object" && Object.keys(parsedCoupon).length > 0) {
                        setSelectedCoupon(parsedCoupon);
                        setInitialValuesCoupon(parsedCoupon);
                    } else {
                        setSelectedCoupon(null);
                        setInitialValuesCoupon(null);
                    }
                } else {
                    setSelectedCoupon(null);
                    setInitialValuesCoupon(null);
                }

                // setOrderID(oID);

            } else {
                alert(`Problem: ${orderResult.msg}`);
            }
        } else {
            alert('Please specify the number of passes you would like to book.');
        }
    }

    // ✅ Coupon handling
    const handleCouponApply = (coupon) => {
        setSelectedCoupon(coupon);
        handleCouponApplyAPI(coupon);
        setShowModal(false);
    };

    const handleCouponApplyAPI = async (coupon, latitude, longitude) => {

        if (orderID === null) {
            return;
        }

        const formData = new FormData();
        formData.append("user_id", userdata.id);
        formData.append("pass_id", checkoutData.eventDetails.id);
        formData.append("order_id", orderID);
        formData.append("coupon", coupon.code);

        try {
            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/Carnival/applyCarnivalCoupon`,
                formData
            );
            const responseData = response.data;

            console.log("Coupon applied successfully", responseData);
            if (responseData.res === "success") {
                placeOrder();
            } else {
                setError(responseData.msg || "Failed to apply coupon");
            }
        } catch (e) {
            console.log(e);
            if (e.code === "ECONNABORTED") {
                setError("Request timeout. Please try again.");
            } else if (e.response) {
                setError(`Server error: ${e.response.status}`);
            } else if (e.request) {
                setError("Network error. Please check your connection.");
            } else {
                setError("An unexpected error occurred.");
            }
        }
    }

    const handleRemoveCouponAPI = async (latitude, longitude) => {

        if (orderID === null) {
            return;
        }

        const formData = new FormData();
        formData.append("user_id", userdata.id);
        formData.append("pass_id", checkoutData.eventDetails.id);
        formData.append("order_id", orderID);

        try {
            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/Carnival/removeCarnivalCoupon`,
                formData
            );
            const responseData = response.data;

            console.log("Coupon removed successfully", responseData);
            if (responseData.status) {
                placeOrder();
            } else {
                setError(responseData.msg || "Failed to remove coupon");
            }
        } catch (e) {
            console.log(e);
            if (e.code === "ECONNABORTED") {
                setError("Request timeout. Please try again.");
            } else if (e.response) {
                setError(`Server error: ${e.response.status}`);
            } else if (e.request) {
                setError("Network error. Please check your connection.");
            } else {
                setError("An unexpected error occurred.");
            }
        }
    }

    const handleRemoveCoupon = () => {
        setSelectedCoupon(null);
        handleRemoveCouponAPI();
    };

    const handleFetchCoupon = async () => {
        const formData = new FormData();
        formData.append("user_id", userdata.id);
        formData.append("pass_id", checkoutData.eventDetails.id);

        try {
            const response = await axios.post(
                `${API_BASE_URL}/master/APIs/Carnival/getCarnivalCoupons`,
                formData
            );
            if (response.data?.all_coupons) {
                setAvailableCoupons(response.data.all_coupons);
                console.log('Available Coupons: ', response.data.all_coupons);
            } else {
                setAvailableCoupons([]);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleProceedToCheckout = () => {
        if (!orderData?.order_id) {
            setError("Order ID not found");
            return;
        }
        handleRazorpayScreen(orderData);
    };

    // const estimateOrder = async (e) => {
    //     const orderForm = getOrderInput();
    //     if (orderForm) {
    //         const orderResult = await axios.post(`${API_BASE_URL}/master/APIs/Carnival/EstimateOrder`, orderForm);
    //         const estimate = orderResult?.data;

    //         console.log('Order Estimate: ', estimate);
    //         setCouponAmount(Number.parseFloat(estimate?.discounted_amount || '0'));
    //         setPlatformFee(Number.parseFloat(estimate?.platform_fee || '0'));
    //         setGrandTotal(Number.parseFloat(estimate?.net_payable_amount || '0'));
    //         setUsableCarrot(Number.parseFloat(estimate?.carrot_used_amount || '0'));

    //         alert('Order Estimated');
    //     }
    // }


    const initializeRazorpay = (paymentData) => {
        if (!window.Razorpay) {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => openRazorpay(paymentData);
            script.onerror = () =>
                setError("Failed to load Razorpay. Please try again.");
            document.body.appendChild(script);
        } else {
            openRazorpay(paymentData);
        }
    };

    const openRazorpay = (paymentData) => {
        const userData = JSON.parse(localStorage.getItem("userData") || "{}");

        console.log("paymentdata", paymentData);

        const options = {
            key: process.env.REACT_APP_RAZORPAY_KEY,
            amount: paymentData.amount * 100,
            currency: "INR",
            name: "PartyWitty",
            description: `PartyWitty Booking - Order ${orderData?.order_id}`, // ✅ fixed
            order_id: paymentData.rzp_order_id,
            prefill: {
                name: userData.name || "",
                email: userData.email || "",
                contact: paymentData.userMobile || userData.mobile || "",
            },
            theme: {
                color: "#FF6B6B",
            },
            modal: {
                ondismiss: () => {
                    setProcessing(false);
                    setError("Payment cancelled by user");
                },
            },
            handler: async function (response) {
                try {
                    const verified = await verifyRazorpayPayment(response);
                    if (verified) {
                        navigate(`/event/thank-you`, {
                            state: {
                                orderId: orderData?.order_id,
                                transactionId: response.razorpay_payment_id,
                                razorpayOrderId: response.razorpay_order_id,
                                signature: response.razorpay_signature,
                            },
                        });
                    } else {
                        setError("Payment verification failed. Please contact support.");
                    }
                } catch (error) {
                    console.error("Payment verification error:", error);
                    setError("Something went wrong during payment verification.");
                }
            },
        };

        const rzp = new window.Razorpay(options);
        rzp.on("payment.failed", (response) => {
            console.error("Razorpay payment failed:", response);
            setError(`Payment failed: ${response.error.description}`);
            setProcessing(false);
        });

        rzp.open();
    };

    const handleCheckCarnivals = async () => {
        const formData = new FormData();
        formData.append("order_id", orderID);
        formData.append("coupon_code", selectedCoupon?.code || "");
        formData.append("payment_gateway", paymentGateway);
        formData.append("carrot_use", useCarrot ? "true" : "false");
        try {
            const response = await axios.post(`${API_BASE_URL}/master/APIs/Carnival/submitCarnivalPass`, formData); //response 

            console.log("response data check out ", response.data);

            if (response.data?.status) {
                initializeRazorpay(response.data.order);
            } else {
                setError(response.data?.msg || "Failed to apply coupon");
            }
        }
        catch (e) {
            console.log(e);
        }
    }

    //  Carnival end

    // Load checkoutData and trigger correct flow
    useEffect(() => {
        const savedCheckoutData = localStorage.getItem("checkoutData");

        if (!savedCheckoutData) {
            navigate("/");
            return;
        }

        try {
            const parsedData = JSON.parse(savedCheckoutData);
            setCheckoutData(parsedData);
            setIsFreeTickets(parsedData.isFreeTiket);
        } catch (error) {
            console.error("Error parsing checkout data:", error);
            navigate("/");
        }
    }, [navigate]);

    // Run order placement only after checkoutData is set
    useEffect(() => {
        if (!checkoutData) {
            console.log("checkoutData not ready yet");
            return;
        }

        console.log("checkoutData ready:", checkoutData);

        if (checkoutData.type === "carnival") {
            console.log("isCarnival");
            placeOrder();
            handleFetchCoupon();
        } else {
            console.log("isEvent");
            handleEventPlaceOrder();
        }
    }, [checkoutData]);




    console.log('orderData', orderData);
    console.log('checkoutData', checkoutData);
    console.log('setIsFreeTickets', isFreeTikets);



    if (!checkoutData) {
        return (
            <div className="checkout-page">
                <div className="loading">Loading...</div>
            </div>
        );
    }

    return (
        <>
            <div className="event-checkout-page">
                <div className="event-checkout-container">
                    <div className="event-checkout-wrapper">
                        <div className="event-checkout-header">
                            <button onClick={handleGoBack} className="event-back-btn">
                                <FaArrowLeft />
                            </button>
                            <h2>Order Summay</h2>
                        </div>

                        <div className="event-checkout-content">
                            {/* Event Information */}
                            {isCarnival ? (
                                <>
                                    <div className="event-checkout-event-info">
                                        <h4>
                                            {checkoutData.eventDetails.name}
                                            {checkoutData.eventDetails.categoryName && (
                                                <span> ({checkoutData.eventDetails.categoryName})</span>
                                            )}
                                        </h4>
                                        <p>{checkoutData.eventDetails.clubName}</p>

                                        <div className='event-checkout-event-details'>
                                            <p className="event-checkout-event-address">
                                                <FaLocationDot />
                                                {checkoutData.eventDetails?.club.address}
                                            </p>
                                            <p>
                                                <SlCalender />
                                                {checkoutData.eventDetails?.event_date} | {checkoutData.eventDetails?.start_time} Onwards
                                            </p>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="event-checkout-event-info">
                                        <h4>
                                            {checkoutData.eventDetails.name}
                                            {checkoutData.eventDetails.categoryName && (
                                                <span> ({checkoutData.eventDetails.categoryName})</span>
                                            )}
                                        </h4>
                                        <p>{checkoutData.eventDetails.clubName}</p>

                                        <div className='event-checkout-event-details'>
                                            <p className="event-checkout-event-address">
                                                <FaLocationDot />
                                                {checkoutData.eventDetails?.clubArea} {","} {checkoutData.eventDetails?.clubCity}
                                            </p>
                                            <p>
                                                <SlCalender />
                                                {checkoutData.eventDetails?.event_date} | {checkoutData.eventDetails?.event_time}
                                            </p>
                                        </div>
                                    </div>
                                </>
                            )}


                            {/* Selected Tickets */}

                            {isCarnival ? (
                                <>
                                    <div className="event-checkout-tickets-section">
                                        <h3>Selected Tickets</h3>
                                        <div className="event-selected-tickets-list">
                                            {checkoutData.selectedTickets.map((ticket) => (
                                                <div key={ticket.id} className="event-selected-ticket-item">
                                                    <div className="event-ticket-details">
                                                        <h5>{ticket.ticket_type}</h5>
                                                        <p className="event-ticket-description" dangerouslySetInnerHTML={{ __html: ticket.des }} />
                                                        <div className="event-ticket-quantity">
                                                            Quantity: {ticket.quantity}
                                                        </div>
                                                    </div>
                                                    <div className="event-ticket-price">
                                                        {parseFloat(ticket.price) === 0
                                                            ? ""
                                                            : `${formatIndianCurrency(ticket.price)} × ${ticket.quantity}`
                                                        }
                                                        {parseFloat(ticket.price) > 0 && (
                                                            <div className="event-ticket-subtotal">
                                                                = {formatIndianCurrency(parseFloat(ticket.price) * ticket.quantity)}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="event-checkout-tickets-section">
                                        <h3>Selected Tickets</h3>
                                        <div className="event-selected-tickets-list">
                                            {checkoutData.selectedTickets.map((ticket) => (
                                                <div key={ticket.id} className="event-selected-ticket-item">
                                                    <div className="event-ticket-details">
                                                        <h5>{ticket.name}</h5>
                                                        <p className="event-ticket-description" dangerouslySetInnerHTML={{ __html: ticket.des }} />
                                                        <div className="event-ticket-quantity">
                                                            Quantity: {ticket.quantity}
                                                        </div>
                                                    </div>
                                                    <div className="event-ticket-price">
                                                        {parseFloat(ticket.price) === 0
                                                            ? ""
                                                            : `${formatIndianCurrency(ticket.price)} × ${ticket.quantity}`
                                                        }
                                                        {parseFloat(ticket.price) > 0 && (
                                                            <div className="event-ticket-subtotal">
                                                                = {formatIndianCurrency(parseFloat(ticket.price) * ticket.quantity)}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </>
                            )}


                            <div className="bid-order-summery-page">
                                {/* Price Summary */}
                                <div className="price-summary-card">
                              
    
                                    <div className="summary-amounts">



                                        {/* <hr /> */}
                                        {isCarnival ? (
                                            <div className="summary-line total">
                                                <strong className='summary-line-final-price-text'>Booking Amount (Book Now)</strong>
                                                <strong className='summary-line-final-price-total'>₹{parseFloat(orderData?.payable_amount || 0).toFixed(2)}</strong>
                                            </div>
                                        ) : (
                                            <>
                                                <div className="summary-line total">
                                                    {!isFreeTikets && (<>
                                                        <strong className='summary-line-final-price-text'>Booking Amount (Book Now)</strong>
                                                        <strong className='summary-line-final-price-total'>₹{parseFloat((Number(orderData?.net_payable_amount) - Number(orderData?.platform_fee)) || 0).toFixed(2)}</strong>
                                                    </>
                                                    )}
                                                </div>
                                            </>
                                        )}



                                        <div className='pay-later-tag'>
                                            <h1>Book now - pay later!!!</h1>
                                        </div>


                                        {/* Carrot Section */}

                                        {isCarnival && (
                                            <>


                                                <div className="carrot-section">
                                                    <div className="carrot-header">

                                                        <span>
                                                            Available Carrot Balance: <span className="carrot-icon">🥕</span>{" "}
                                                            {orderData?.remainingCarrot - (useCarrot ? parseFloat(amounts?.carrotDiscount || 0).toFixed(2) : 0)}
                                                        </span>

                                                    </div>
                                                    <label className="carrot-checkbox">
                                                        <div className='carrot-checkbox-container'>
                                                            {amounts?.usableCarrot > 0 && (
                                                                <input
                                                                    type="checkbox"
                                                                    checked={useCarrot}
                                                                    onChange={(e) => setUseCarrot(e.target.checked)}
                                                                />
                                                            )}
                                                            <div className='carrot-checkbox-text'>
                                                                <p className='carrot-checkbox-text-1'>Pay Using Carrot Balance</p>
                                                                <p className='carrot-checkbox-text-2'>Use Carrot Balance 🥕 {amounts?.usableCarrot}</p>
                                                            </div>
                                                        </div>

                                                    </label>
                                                </div>


                                                <div className='pay-later-tag'>
                                                    {useCarrot ? (
                                                        <h2>Great Choice! ₹{Number(amounts?.carrotDiscount) + Number(amounts?.couponDiscount)} Saved Instantly on This Booking!</h2>
                                                    ) : (

                                                        <h2>Use Carrots! To Save on your Booking Amount</h2>
                                                    )}
                                                </div>

                                                {/* Coupon Section */}

                                                <div className="coupon-section-container">
                                                    <p>Coupons</p>
                                                    <div className="coupon-section">
                                                        <div className="coupon-input-group">
                                                            <input
                                                                type="text"
                                                                className="coupon-input"
                                                                value={selectedCoupon?.code || ''}
                                                                placeholder="Enter coupon code"
                                                                readOnly
                                                            />
                                                            <button
                                                                className="coupon-btn"
                                                                onClick={() => setShowModal(true)}
                                                            >
                                                                {selectedCoupon ? 'Change' : 'View Coupons'}
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                                {selectedCoupon && (
                                                    <div className="coupon-applied">
                                                        <span className="coupon-success">✅ Coupon Applied!</span>
                                                        <span className="coupon-discount">You saved ₹{amounts?.couponDiscount.toFixed(2)}</span>
                                                        <button onClick={handleRemoveCoupon} className="remove-coupon">Remove</button>
                                                    </div>
                                                )}

                                            </>
                                        )}


                                        {isCarnival ? (
                                            <>
                                                <div className="summary-line">
                                                    <span>Booking Amount (Advance)</span>
                                                    <span>₹{parseFloat(orderData?.payable_amount || 0).toFixed(2)}</span>
                                                </div>

                                                <div className="summary-line-platform">
                                                    <PlatformChargesTooltip
                                                        content={
                                                            <div className='platform-charges-tooltip'>
                                                                <p className='platform-charges-tooltip-text'><span>Platform Charges</span><span>₹5.00</span></p>
                                                                <p className='platform-charges-tooltip-text'><span>GST On Platform</span><span>₹0.90</span></p>
                                                                <hr />
                                                                <p className='platform-charges-tooltip-text'><strong>Total</strong><strong>₹5.90</strong></p>
                                                            </div>
                                                        }
                                                    >
                                                        <span className='order-summery-other-charges'>Platform & Other Charges</span>
                                                    </PlatformChargesTooltip>
                                                    {/* <span className='order-summery-other-charges'>Platform & Other Charges</span> */}
                                                    <span>₹5.90</span>
                                                </div>

                                            </>
                                        ) : (
                                            <>
                                                {isFreeTikets ? (
                                                    <>
                                                        <div className="summary-line"> </div>
                                                        <div className="summary-line-platform">
                                                            <PlatformChargesTooltip
                                                                content={
                                                                    <div className='platform-charges-tooltip'>
                                                                        <p className='platform-charges-tooltip-text'><span>Platform Charges</span><span>₹50.00</span></p>
                                                                        <p className='platform-charges-tooltip-text'><span>GST On Platform</span><span>₹9.00</span></p>
                                                                        <hr />
                                                                        <p className='platform-charges-tooltip-text'><strong>Total</strong><strong>₹59.00</strong></p>
                                                                    </div>
                                                                }
                                                            >
                                                                <span className='order-summery-other-charges'>Platform & Other Charges</span>
                                                            </PlatformChargesTooltip>
                                                            {/* <span className='order-summery-other-charges'>Platform & Other Charges</span> */}
                                                            <span>₹59.00</span>
                                                        </div>

                                                    </>

                                                ) : (
                                                    <>
                                                        <div className="summary-line">
                                                            <span>Booking Amount (Advance)</span>
                                                            <span>₹{parseFloat((Number(orderData?.net_payable_amount) - Number(orderData?.platform_fee)) || 0).toFixed(2)}</span>
                                                        </div>

                                                        <div className="summary-line-platform">
                                                            <PlatformChargesTooltip
                                                                content={
                                                                    <div className='platform-charges-tooltip'>
                                                                        <p className='platform-charges-tooltip-text'><span>Platform Charges</span><span>₹5.00</span></p>
                                                                        <p className='platform-charges-tooltip-text'><span>GST On Platform</span><span>₹0.90</span></p>
                                                                        <hr />
                                                                        <p className='platform-charges-tooltip-text'><strong>Total</strong><strong>₹5.90</strong></p>
                                                                    </div>
                                                                }
                                                            >
                                                                <span className='order-summery-other-charges'>Platform & Other Charges</span>
                                                            </PlatformChargesTooltip>
                                                            {/* <span className='order-summery-other-charges'>Platform & Other Charges</span> */}
                                                            <span>₹5.90</span>
                                                        </div>

                                                    </>
                                                )}
                                            </>
                                        )}



                                    </div>


                                    {isCarnival ? (
                                        <>

                                            <div className="summary-line">
                                                <strong>Grand Total</strong>
                                                <strong>
                                                    {selectedCoupon?.id === initialValuesCoupon?.id
                                                        ? `₹${parseFloat(Number(orderData?.payable_amount) + Number(orderData?.platform_fee) || 0).toFixed(2)}`
                                                        : `₹${amounts?.netPayableAmount.toFixed(2)}`}
                                                </strong>
                                            </div>
                                        </>) : (
                                        <>
                                            <div className="summary-line">
                                                <strong>Grand Total</strong>
                                                <strong>₹{amounts?.netPayableAmount.toFixed(2)}</strong>
                                            </div>
                                        </>
                                    )}

                                    {(amounts?.carrotDiscount > 0) && (
                                        <div className="summary-line">
                                            <span className='order-summery-carrot'>Used Carrots</span>
                                            <span className='order-summery-carrot'>-₹{amounts?.carrotDiscount.toFixed(2)}</span>
                                        </div>
                                    )}

                                    {(amounts?.couponDiscount > 0) && (
                                        <div className="summary-line">
                                            <span>Coupon Discount</span>
                                            <span className='order-summery-coupon'>-₹{amounts?.couponDiscount.toFixed(2)}</span>
                                        </div>
                                    )}

                                    {(amounts?.carrotDiscount > 0 || amounts?.couponDiscount > 0) && (
                                        <div className="summary-line">
                                            <strong>Amount Payable</strong>
                                            <strong className="final-price">₹{amounts?.finalPayableAmount.toFixed(2)}</strong>
                                        </div>
                                    )}


                                    

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className='proceed-to-payment-section'>
                                        <div className='proceed-to-payment-wrapper'>

                                            <button className="order-proceed-btn icon-btn-44">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 6" fill="none">
                                                    <path d="M3.50008 0C1.94175 0 0.666748 1.35 0.666748 3C0.666748 4.65 1.94175 6 3.50008 6C5.05841 6 6.33341 4.65 6.33341 3C6.33341 1.35 5.05841 0 3.50008 0ZM20.5001 0C18.9417 0 17.6667 1.35 17.6667 3C17.6667 4.65 18.9417 6 20.5001 6C22.0584 6 23.3334 4.65 23.3334 3C23.3334 1.35 22.0584 0 20.5001 0ZM12.0001 0C10.4417 0 9.16675 1.35 9.16675 3C9.16675 4.65 10.4417 6 12.0001 6C13.5584 6 14.8334 4.65 14.8334 3C14.8334 1.35 13.5584 0 12.0001 0Z" fill="white"/>
                                                    </svg>
                                            </button>
                                            <button
                                                className="order-proceed-btn"
                                                onClick={isCarnival ? handleCheckCarnivals : handleProceedToCheckout}
                                                disabled={!orderData?.order_id}
                                            >
                                                {(amounts?.carrotDiscount > 0 || amounts?.couponDiscount > 0) ? (
                                                    <div className="">
                                                        <span >₹{amounts?.finalPayableAmount.toFixed(2)}</span>
                                                    </div>
                                                ) : (<div className="">
                                                    <span>₹{amounts?.netPayableAmount.toFixed(2)}</span>
                                                </div>)} Proceed to Payment
                                            </button>
                                        </div>
                                    </div>
            </div >

            {showLoginPopup && (
                <Loginpopup onClose={() => setShowLoginPopup(false)} />
            )
            }

            <CouponModal
                show={showModal}
                onClose={() => setShowModal(false)}
                availableCoupons={availableCoupons}
                onApplyCoupon={handleCouponApply}
                selectedCoupon={selectedCoupon}
                orderAmount={amounts?.payableAmount || 0}
            />
        </>
    );
}